import { Box, Grid } from '@mui/material';
import { useAppSelector } from 'app/hooks';
import { NormalButton } from 'components/atoms/Button';
import Loader from 'components/atoms/loader';
import NormalSearchInput from 'components/molecules/InputText/NormalSearchInput';
import { selectAuth } from 'features/auth/authSlice';
import { selectChat } from 'features/auth/chatSlice';
import { UserData } from 'interfaces/UserData.interface';
import { FC, useCallback, useEffect, useState } from 'react';
import {
  LightBg,
  ParaText,
  SearchInputCont,
  Section,
  TabsWrapper,
} from './DMessage.styles';
import SingleMessageRow from './SingleMessageRow';

interface IInboxPeople {
  handleChangeIndex: (i: number) => void;
  currentTab: string;
  setCurrentTab: any;
}

const InboxPeople: FC<IInboxPeople> = ({
  handleChangeIndex,
  currentTab,
  setCurrentTab,
}) => {
  const authState = useAppSelector(selectAuth);
  const chatState = useAppSelector(selectChat);
  const [subscribers, setSubscribers] = useState<number[]>([]);
  const [searchPeople, setSearchPeople] = useState<
    { user: UserData; lastMessageTime: number }[]
  >([]);
  const [query, setQuery] = useState<string>('');

  const handleFilter = (query: string) => {
    query = query.toLowerCase();
    if (chatState) {
      const users: { user: UserData; lastMessageTime: number }[] =
        chatState.inboxUsers.filter(user => {
          const username = user.user.username.toLowerCase();
          return username.includes(query);
        });
      setSearchPeople(users);
    }
  };

  const indexHandler = useCallback(
    (username: string) => {
      if (!(chatState.inboxUsers.length > 0)) return;
      else {
        const index = chatState.inboxUsers.findIndex(
          user => user.user.username === username
        );
        handleChangeIndex(index);
        if (
          authState.generalChats.includes(chatState.inboxUsers[index].user.id)
        ) {
          setCurrentTab('General');
        } else if (
          authState.subscribers?.some(
            user => user.from.id === chatState.inboxUsers[index].user.id
          )
        )
          setCurrentTab('Backstage');
        else {
          setCurrentTab('Requests');
        }
      }
    },
    //eslint-disable-next-line
    [chatState.inboxUsers]
  );

  const getSubscribers = useCallback(async () => {
    if (authState.subscribers) {
      setSubscribers(authState.subscribers.map(e => e.from?.id));
    } else return;
    //eslint-disable-next-line
  }, [authState.id]);

  useEffect(() => {
    getSubscribers();
    if (!(chatState.inboxUsers.length > 0)) return;
    else {
      if (
        authState.generalChats.includes(
          chatState.inboxUsers[chatState.currentIndex].user.id
        )
      ) {
        setCurrentTab('General');
      } else if (
        authState.subscribers?.some(
          user =>
            user.from.id ===
            chatState.inboxUsers[chatState.currentIndex].user.id
        )
      )
        setCurrentTab('Backstage');
      else {
        setCurrentTab('Requests');
      }
    }
    //eslint-disable-next-line
  }, [authState.id]);

  const authStateFollowing: number[] =
    authState?.following?.map(following => following.following.id) || [];

  return (
    <Section item xs={3.3}>
      <SearchInputCont item xs={12}>
        <NormalSearchInput
          placeholder="Search Messages"
          onChange={e => {
            handleFilter(e.target.value);
            setQuery(e.target.value);
          }}
        />
      </SearchInputCont>

      <LightBg sx={{ maxHeight: '70vh' }}>
        <Grid container>
          <Grid item xs={12} style={{ padding: '10px' }}>
            <TabsWrapper>
              <Box
                style={{
                  display: 'flex',
                  gap: '5px',
                  flexWrap: 'wrap',
                  justifyContent: 'center',
                }}
              >
                <NormalButton
                  color={`${
                    currentTab === 'General' ? 'yellow' : 'transparent'
                  }`}
                  style={{
                    width: '32%',
                    padding: '.8rem 1rem',
                    borderRadius: '15px',
                    whiteSpace: 'nowrap',
                  }}
                  onClick={() => setCurrentTab('General')}
                >
                  General
                </NormalButton>
                <NormalButton
                  isDisabled={!authState.canPost}
                  color={`${
                    currentTab === 'Backstage' ? 'yellow' : 'transparent'
                  }`}
                  style={{
                    width: '32%',
                    padding: '.8rem 1rem',
                    borderRadius: '15px',
                    whiteSpace: 'nowrap',
                  }}
                  onClick={() => setCurrentTab('Backstage')}
                >
                  Backstage
                </NormalButton>
                <NormalButton
                  color={`${
                    currentTab === 'Requests' ? 'yellow' : 'transparent'
                  }`}
                  style={{
                    width: '32%',
                    padding: '.8rem 1rem',
                    borderRadius: '15px',
                    whiteSpace: 'nowrap',
                  }}
                  onClick={() => setCurrentTab('Requests')}
                >
                  {'Requests'}
                </NormalButton>
              </Box>
            </TabsWrapper>
          </Grid>

          <Grid
            item
            xs={12}
            className="scrollbar-hidden"
            style={{
              maxHeight: '100vh',
              minHeight: '80vh',
              overflowX: 'hidden',
              overflowY: 'auto',
            }}
          >
            {chatState.loading ? (
              <Loader />
            ) : chatState.inboxUsers.length === 0 ? (
              <Grid item xs={12} style={{ margin: '1rem .5rem' }}>
                <ParaText>No Result Found</ParaText>
              </Grid>
            ) : currentTab === 'General' ? (
              /*eslint-disable*/
              chatState.inboxUsers
                .filter(e => {
                  if (e.user.id) {
                    if (
                      !subscribers.includes(e.user.id) &&
                      (authStateFollowing.includes(e.user.id) ||
                        authState.generalChats.includes(e.user.id))
                    ) {
                      if (searchPeople.length > 0 || query.length > 0) {
                        if (
                          searchPeople.some(user => user.user.id === e.user.id)
                        )
                          return true;
                        else return false;
                      } else {
                        return true;
                      }
                    } else return false;
                  }
                })
                .sort((a, b) => b.lastMessageTime - a.lastMessageTime)
                .map((user, i) => {
                  return (
                    <SingleMessageRow
                      user={user.user}
                      index={i}
                      indexHandler={indexHandler}
                    />
                  );
                })
            ) : currentTab === 'Backstage' ? (
              chatState.inboxUsers
                .filter(e => {
                  if (e.user.id) {
                    if (subscribers.includes(e.user.id)) {
                      if (searchPeople.length > 0 || query.length > 0) {
                        if (
                          searchPeople.some(user => user.user.id === e.user.id)
                        )
                          return true;
                        else return false;
                      } else {
                        return true;
                      }
                    } else return false;
                  }
                })
                .sort((a, b) => b.lastMessageTime - a.lastMessageTime)

                .map((user, i) => {
                  return (
                    <SingleMessageRow
                      user={user.user}
                      index={i}
                      indexHandler={indexHandler}
                    />
                  );
                })
            ) : (
              chatState.inboxUsers
                .filter(e => {
                  if (e.user.id) {
                    if (
                      !subscribers.includes(e.user.id) &&
                      !authStateFollowing.includes(e.user.id) &&
                      !authState.generalChats.includes(e.user.id)
                    ) {
                      if (searchPeople.length > 0 || query.length > 0) {
                        if (
                          searchPeople.some(user => user.user.id === e.user.id)
                        )
                          return true;
                        else return false;
                      } else {
                        return true;
                      }
                    } else return false;
                  }
                })
                .sort((a, b) => b.lastMessageTime - a.lastMessageTime)

                .map((user, i) => {
                  return (
                    <SingleMessageRow
                      user={user.user}
                      index={i}
                      indexHandler={indexHandler}
                    />
                  );
                })
            )}
          </Grid>
        </Grid>
      </LightBg>
    </Section>
  );
};

export default InboxPeople;
